'use strict';
import React, {Fragment} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';


export function ValidationErrorMessagesView(props) {
  return (
    <Fragment>
      {props.validationMessages.map(x => (
        <div
          key={x}
          className="ValidationErrorMessages__message"
        >
          {x}
        </div>
      ))}
    </Fragment>
  );
}

ValidationErrorMessagesView.propTypes = {
  className: T.string,
  validationMessages: T.array,
};

ValidationErrorMessagesView.defaultProps = {
  validationMessages: [],
};



// WEBPACK FOOTER //
// ./src/js/components/forms/ValidationErrorMessages/ValidationErrorMessagesView.js